import MainButton from "./MainButton";
import "./styles.css";

export default MainButton;



// WEBPACK FOOTER //
// ./src/library/button/MainButton/index.js